import lodash from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Layout } from 'antd';
import { Paper } from '@material-ui/core';
import { checkPermissionsHOC } from '../../App/CheckPermissions';
import PageTitle from '../../../common/components/PageTitle';
import { NotFound } from '../../App/components/NotFound';
import CustomersTable from './components/CustomersTable';
import { VIEW_CUSTOMERS_LIST_URL } from './constants';
import { VIEW_LEAD_PROFILE_URL } from '../LeadPaymentApproval/constants';

const urls = [VIEW_CUSTOMERS_LIST_URL, VIEW_LEAD_PROFILE_URL];

class Index extends Component {
    render() {
        const { views_permissions, location } = this.props;
        const pageAccess = views_permissions[VIEW_CUSTOMERS_LIST_URL];
        const leadProfileAccess = views_permissions[VIEW_LEAD_PROFILE_URL];
        const search = lodash.get(location, 'search');
        const searchParams = new URLSearchParams(search);
        const customerPhone = searchParams.get('customerPhone');
        const divisionId = searchParams.get('divisionId');

        // URL example
        // http://localhost:3001/Leads/customers-list?divisionId=5be93e5f683059f77dbcef4b&customerPhone=380631870668

        if (!pageAccess) {
            return <NotFound />;
        }

        return (
            <Layout>
                <Row>
                    <Col span={24}>
                        <PageTitle
                            title="Leads Customers"
                            subhead="List of customers from the leads"
                        />
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Paper>
                            <CustomersTable
                                leadProfileAccess={leadProfileAccess}
                                customerPhone={customerPhone}
                                divisionId={divisionId}
                            />
                        </Paper>
                    </Col>
                </Row>
            </Layout>
        );
    }
}

const mapStateToProps = (state) => ({
    views_permissions: state.App.Permissions.views_permissions,
});

export default connect(mapStateToProps)(checkPermissionsHOC(Index, urls));



// WEBPACK FOOTER //
// ./src/modules/Leads/CustomersList/index.js